<template>
    <Popin
            ref="popin"
            :title="$t('order.refund.reason_popin.title')"
            :subtitle="$t('order.refund.reason_popin.text')"
            :center="true"
    >
        <template #bottom>
            <Button size="xl" color="grey" @click.native="$emit('cancel')">{{ $t('global.cancel') }}</Button>
            <Button size="xl" color="green" @click.native="$emit('confirm')">{{ $t('global.confirm') }}</Button>
        </template>
    </Popin>
</template>

<script>
import Popin from '@/components/ui/popin/Popin';
import Button from '@/components/ui/button/Button';

export default {
    name: 'RefundReasonPopin',
    components: {
        Popin,
        Button,
    },
    mounted() {
        this.$refs.popin.open();
    },
    beforeDestroy() {
        this.$refs.popin.close();
    }
};
</script>
